import { Component, OnInit } from '@angular/core';

import { AppDateType } from '../../../../core/types/app-date-type.type';

@Component({
    selector: 'app-operators-today-statistics',
    templateUrl: './operators-today-statistics.component.html',
    standalone: false
})
export class OperatorsTodayStatisticsComponent implements OnInit {

  title: string = "pages.operatorsTodayStatistics.title";
  doughnutChartId: string = "doughnut_todayStatisticsByOperator";
  barChartId: string = "bar_todayStatisticsByOperator";
  getItemsApiMethodName: string = "statisticsGetTodayStatisticsByOperator";
  dateType: AppDateType = "other";
  constructor() { }

  ngOnInit(): void { }

}
